import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { SERVICES } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

const Card = ({ s, index }) => (
  <Reveal
    delay={index * 0.08}
    className={`${s.span} ${s.tall ? "min-h-[60vh]" : "min-h-[42vh]"}`}
  >
    <div
      data-testid={`service-card-${s.id}`}
      className="group relative h-full w-full overflow-hidden border border-white/10 bg-[#1C1C1A]"
    >
      <img
        src={s.image}
        alt={s.title}
        className="absolute inset-0 h-full w-full object-cover grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-[900ms] ease-out"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#111110] via-[#111110]/30 to-transparent" />
      <div className="relative h-full p-8 flex flex-col justify-between">
        <div className="flex items-start justify-between">
          <span className="font-mono text-xs tracking-[0.2em] text-[#C05C3F]">
            {s.num}
          </span>
          <ArrowUpRight className="h-6 w-6 text-[#F4F3F0]/40 group-hover:text-[#C05C3F] group-hover:rotate-45 transition-all duration-500" />
        </div>
        <div>
          <h3 className="font-serif text-3xl sm:text-4xl font-light text-[#F4F3F0] mb-2">
            {s.title}
          </h3>
          <p className="max-w-sm text-sm text-[#F4F3F0]/70 font-light leading-relaxed opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
            {s.blurb}
          </p>
        </div>
      </div>
    </div>
  </Reveal>
);

export const Work = () => (
  <section
    id="work"
    data-testid="work-section"
    className="max-w-7xl mx-auto px-6 lg:px-8 py-24 sm:py-32"
  >
    <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
      <div>
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#C05C3F]">
          / What we build
        </span>
        <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#F4F3F0] max-w-2xl leading-[0.95]">
          Four disciplines, <span className="italic">one obsession</span> with finish.
        </h2>
      </div>
      <p className="max-w-xs text-sm text-[#F4F3F0]/60 font-light leading-relaxed">
        Every project is drawn, costed and built in-house. Hover to read the
        detail behind each craft.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
      {SERVICES.map((s, i) => (
        <Card key={s.id} s={s} index={i} />
      ))}
    </div>
  </section>
);
